import { render, staticRenderFns } from "./ConfirmAddDocument.vue?vue&type=template&id=652033a8&scoped=true&"
import script from "./ConfirmAddDocument.vue?vue&type=script&lang=js&"
export * from "./ConfirmAddDocument.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAddDocument.vue?vue&type=style&index=0&id=652033a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652033a8",
  null
  
)

export default component.exports